<template>
	<div class="row centered">
		<AppTable ref="balance-transactions-table"
			v-if="userStore.currBusinessId"
			:fetch-function="fetchFunction"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('balance_transactions')"
			:total-items="cardsStore.cardTransactionsTableTotal || 0"
			:items="cardsStore.cardTransactionsTable || []"
			initial-sort-field="date"
			initial-sort-dir="DESC"
			@failed-fetch="details=>{$emit('failed-fetch', details)}" >

		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import {useCardsStore, useUserStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const userStore = useUserStore();
		const cardsStore = useCardsStore();
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {userStore, cardsStore, getString: languageStore.getString, currencyStore}
	},
	name: "BalanceTransactionsTable",
	emits: ["failed-fetch"],
	components: {AppTable},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'cards_authorizations',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 2,
					sortable: true,
					fieldName: 'date'
				},
				{
					text: this.getString('card'),
					cols: 2,
					fieldName: 'card_name',
				},
				{
					text: this.getString('amount'),
					cols: 2,
					sortable: true,
					fieldName: 'amount',
					formatter: amount => this.currencyStore.readableCurrencyValue(amount, true, true, false)
				},
				{
					text: this.getString('merchant_name'),
					cols: 2,
					fieldName: 'merchant_name'
				},
				{
					text: this.getString('status'),
					cols: 2,
					fieldName: 'display_status',
					formatter: status => {
						const statusMap = {
							'pending': this.getString('pending'),
							'processed': this.getString('processed'),
							'refunded': this.getString('refunded')
						};
						return statusMap[status] || status;
					}
				},
			]
		}
	},
	computed: {
		fetchFunction() {
			// For balance view, always show all cards (cardId = null)
			return (filters, callback) => {
				this.cardsStore.getFilteredCardTransactions(this.userStore.currBusinessId, null, filters, callback);
			};
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				if(this.$refs['balance-transactions-table']) {
					this.$refs['balance-transactions-table'].fetchData();
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">

</style>
